import {z} from 'zod'

export const PaginationModelSchema = z.object({
  page: z.number(),
  pageSize: z.number(),
  totalElements: z.number(),
  totalPages: z.number(),
})

export function PageableResponseSchema(contentItemSchema) {
  return z.object({
    success: z.boolean(),
    content: z.array(contentItemSchema),
    pagination: PaginationModelSchema,
  })
}

export const PaginationItemsModelSchema = z.object({
  page: z.number(),
  pageSize: z.number(),
  totalItems: z.number(),
  totalPages: z.number(),
})

export function PageableResponseItemsSchema(ItemsSchema) {
  return z.object({
    items: z.array(ItemsSchema),
    page: z.number(),
    pageSize: z.number(),
    totalItems: z.number(),
    totalPages: z.number(),
  })
}
